import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { JELLIS_CRAIG_META } from "./meta.ts";
import { parseJellisCraigDetailHtml } from "./parser.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const JELLIS_CRAIG_ADAPTER = defineSoldOnlyAdapter(JELLIS_CRAIG_META, buildSearchUrl, {
  parseDetailHtml: parseJellisCraigDetailHtml,
  // Direct fetch served its search and detail pages in full (probe, 2026-10-14).
  directFirst: true,
});
